<div
    class="relative w-full h-full bg-white dark:bg-slate-900 rounded-2xl shadow-xl overflow-hidden grid grid-cols-1 md:grid-cols-[280px_1fr] lg:grid-cols-[320px_1fr] border border-slate-100 dark:border-slate-800 transition-all duration-300">
    <!-- SIDEBAR / HEADER AREA -->
    <div
        class="h-full bg-gradient-to-br from-white to-slate-50 dark:from-slate-800/50 dark:to-slate-900 p-4 flex flex-col border-b md:border-b-0 md:border-r border-slate-100 dark:border-slate-800 z-10 transition-all duration-300 hidden md:flex">
        <h3 class="text-lg md:text-xl font-bold text-slate-800 dark:text-white mb-1 leading-tight">
            {{ config.title }}
        </h3>
        <p *ngIf="config.subtitle"
            class="text-xs font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-6">
            {{ config.subtitle }}
        </p>

        <!-- Sidebar Custom Chart Container -->
        <div class="flex-1 flex flex-col items-center">
            <div #sidebarChartContainer class="w-full h-[280px] flex items-center justify-center"></div>

            <!-- Revenue Breakdown Rows -->
            <div class="w-full mt-6 space-y-3 px-1">
                <div *ngIf="sidebarData.dailyCronRevenue" class="flex items-center justify-between group">
                    <div class="flex items-center gap-2.5">
                        <div
                            class="w-2 h-2 rounded-full border border-blue-200 bg-blue-500/80 shadow-sm transition-transform group-hover:scale-110">
                        </div>
                        <span
                            class="text-xs font-semibold text-slate-500 dark:text-slate-400 tracking-wide uppercase">Daily
                            Cron
                            Revenue</span>
                    </div>
                    <span class="text-[13px] font-bold text-slate-800 dark:text-white">{{ sidebarData.dailyCronRevenue
                        }}</span>
                </div>

                <div *ngIf="sidebarData.tryAgainRevenue" class="flex items-center justify-between group">
                    <div class="flex items-center gap-2.5">
                        <div
                            class="w-2 h-2 rounded-full border border-emerald-200 bg-emerald-500/80 shadow-sm transition-transform group-hover:scale-110">
                        </div>
                        <span
                            class="text-xs font-semibold text-slate-500 dark:text-slate-400 tracking-wide uppercase">TryAgain
                            Cron
                            Revenue</span>
                    </div>
                    <span class="text-[13px] font-bold text-slate-800 dark:text-white">{{ sidebarData.tryAgainRevenue
                        }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- CHART AREA -->
    <div
        class="relative p-4 h-full min-h-[350px] md:min-h-[400px] flex items-center justify-center bg-slate-50/30 dark:bg-transparent overflow-hidden w-full">
        <!-- Mobile Title (shown only on small screens) -->
        <div class="absolute top-4 left-4 md:hidden z-10">
            <h3 class="text-lg font-bold text-slate-800 dark:text-white mb-1 leading-tight">
                {{ config.title }}
            </h3>
            <p *ngIf="config.subtitle"
                class="text-xs font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                {{ config.subtitle }}
            </p>
        </div>
        <!-- D3 Visual Container -->
        <div #chartContainer class="w-full h-full"></div>
    </div>
</div>